'use client'

import Link, {LinkProps} from 'next/link'
import styled, {css} from 'styled-components'

export const NextLink = ({
  prefetch = false,
  disabled,
  ...rest
}: LinkProps & {children: React.ReactNode; disabled?: boolean}) => {
  return <LinkStyled {...rest} prefetch={prefetch} $disabled={disabled} />
}

const LinkStyled = styled(Link)<{$disabled?: boolean}>`
  ${props =>
    props.$disabled &&
    css`
      &,
      & * {
        pointer-events: none;
        cursor: not-allowed;
      }
    `}
`
